/**
 * @generated SignedSource<<517ac5e61266a89f1e03a4a2d12c524b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingProjects_projectsModule$data = {
  readonly primaryProjectsModule: {
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingProjectItem_projectModule">;
    } | null> | null;
  } | null;
  readonly projectsHeadModule: {
    readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingModuleHeader_header">;
  } | null;
  readonly secondaryProjectsModule: {
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingProjectItem_projectModule">;
    } | null> | null;
  } | null;
  readonly tertiaryProjectsModule: {
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingProjectItem_projectModule">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "InteriorsLandingProjects_projectsModule";
};
export type InteriorsLandingProjects_projectsModule$key = {
  readonly " $data"?: InteriorsLandingProjects_projectsModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingProjects_projectsModule">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "InteriorsLandingModuleItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "InteriorsLandingProjectItem_projectModule"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingProjects_projectsModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingHeadModule",
      "kind": "LinkedField",
      "name": "projectsHeadModule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteriorsLandingModuleHeader_header"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "primaryProjectsModule",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "secondaryProjectsModule",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "tertiaryProjectsModule",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingPage",
  "abstractKey": null
};
})();

(node as any).hash = "1666f7326b307780de2aa3c6a632e857";

export default node;
